<template>
  <section>
    <h2 class="title">Feed</h2>
    <!--p v-if="feed.length === 0">Maybe you don't have friends :(</p-->
    <FeedListItem
      v-for="match in feed"
      :match="match"
      :key="match.id"/>
  </section>
</template>

<script>
import ApiFeed from '@/api/feed'
import FeedListItem from '@/components/FeedListItem'
export default {
  components: {
    FeedListItem
  },
  data () {
    return {
      feed: []
    }
  },
  created () {
    ApiFeed.get.feed().then(response => {
      this.feed = response.body
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FeedList.vue